/**
 * Logo oficial de MEGA Distribuciones y Proyectos S.A.S.
 *
 * Es el vector real (MEGA-logo-4k/mega-logo.svg), no una recreación: cada filo
 * es una línea recta de verdad y el anillo es un círculo matemático. Va en
 * línea dentro del bundle —y no como <img>— para que se pinte en el primer
 * cuadro, sin parpadeo, y para poder controlarlo por props.
 *
 * Trazado y colores tomados sin modificar del archivo de marca:
 *   morado #2D0177 · amarillo #FFC43F · anillo #FFAB00
 */

/** Trazado de la letra amarilla (la "A" estilizada). */
const TRAZO_AMARILLO =
  'M241.74,432.41L238.25,429.59L234.17,418.89L226.42,407.98L218.58,402.97L200.83,401.82L199.50,398.75' +
  'L200.83,394.01L212.21,381.14L217.99,371.36L228.93,361.70L267.20,317.76L328.51,242.25L334.83,231.42' +
  'L333.24,228.17L330.58,227.52L251.75,227.89L240.16,226.99L233.81,223.88L233.01,214.75L235.18,202.42' +
  'L244.67,169.75L253.38,130.75L258.02,126.11L260.92,125.48L384.35,128.33L428.63,130.99L429.00,133.95' +
  'L426.35,139.30L406.52,168.12L364.66,239.08L357.35,248.19L315.45,316.08L305.18,329.79L250.13,419.70' +
  'L246.48,427.97Z'

/** Trazado del isotipo morado (la "M" estilizada). */
const TRAZO_MORADO =
  'M211.97,366.65L209.16,365.81L191.13,336.47L176.85,308.49L108.67,190.78L75.48,130.00L74.83,126.31' +
  'L85.25,124.81L221.25,124.69L263.48,92.00L261.94,97.99L226.51,158.38L173.68,257.44L176.42,261.23' +
  'L261.29,260.31L265.82,262.03L264.17,268.07L242.04,308.08L217.99,359.25Z'

type PropsLogo = {
  /** Alto y ancho en píxeles. El logo es cuadrado. */
  tamano?: number
  /**
   * `completo` incluye el anillo naranja y el disco blanco: es la versión de
   * la marca. `marca` es solo el isotipo, para espacios estrechos como la
   * cabecera del menú lateral, donde el anillo se pierde.
   */
  variante?: 'completo' | 'marca'
  className?: string
}

export function LogoMega({ tamano = 40, variante = 'completo', className }: PropsLogo) {
  return (
    <svg
      className={className}
      width={tamano}
      height={tamano}
      viewBox="0 0 512 512"
      role="img"
      aria-label="MEGA Distribuciones y Proyectos"
      focusable="false"
    >
      {variante === 'completo' && (
        <>
          <circle cx="256.06" cy="255.9" r="247.47" fill="#FFFFFF" />
          <circle
            cx="256.06"
            cy="255.9"
            r="251.59"
            fill="none"
            stroke="#FFAB00"
            strokeWidth="8.24"
          />
        </>
      )}
      <path d={TRAZO_AMARILLO} fill="#FFC43F" fillRule="evenodd" />
      <path d={TRAZO_MORADO} fill="#2D0177" fillRule="evenodd" />
    </svg>
  )
}
